import { SvgIcon } from '@mui/material';

export function ReviewsStar(props) {
	return (
		<SvgIcon
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			{...props}
		>
			<path
				d="M6 0L7.69282 3.67003L11.7063 4.1459L8.73904 6.88997L9.52671 10.8541L6 8.88L2.47329 10.8541L3.26096 6.88997L0.293661 4.1459L4.30718 3.67003L6 0Z"
				fill="currentColor"
			/>
		</SvgIcon>
	);
}
